module.exports = __webpack_public_path__ + "static/fun-time/games/page000_game0/audio//5_rabbit.mp3";